import { configureStore } from '@reduxjs/toolkit'
import chatReducer from './slices/chatSlice'
import conversationReducer from './slices/conversationSlice'
import authReducer from './slices/authSlice'

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    conversations: conversationReducer,
    auth: authReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
